<div class="w-100 jlp-container-location" style="padding:0 !important">
    <rask-date-drill-down [periodFrom]="kundorderrad.periodFrom" [periodTom]="kundorderrad.periodTom" [parent]="this">

        <rask-action-button [disabled]="!canEdit" icon="fas fa-plus" (click)="addForsorjningskalla()"
            aid="buttonAddForsorjningskalla">
            {{ 'KUNDORDER_DETAIL_FORSORJNINGSRAD_ADD' | translate }}
        </rask-action-button>

        <rask-checkbox
            text="Takt {{ dagarKvarInnevarandeManad(taktSettings) }} av {{ taktSettings.totaltAntalArbetsdagarInnevarandeManad }} dgr kvar på inn. mån."
            [(checked)]="taktSettings.showTakt" (click)="toggleTakt()" class="taktCheckbox" aid="chkTakt">
        </rask-checkbox>
        <rask-checkbox
            text="Visa avtalad volym"
            [(checked)]="showAvtaladVolym" (click)="toggleAvtaladVolym()" class="taktCheckbox" aid="chkAvtaladVolym">
        </rask-checkbox>

        <rask-hot-doc [canEdit]="canEdit" [hotDoc]="hotDoc">
        </rask-hot-doc>

    </rask-date-drill-down>
</div>